import { Popover, Segmented } from 'antd'
import { useState } from 'react'

import { ModalSuccess } from '@/components/Modal/ModalSuccess'
import Tooltip from '@/ui/atoms/Tooltip'

import { getCustomCompletePageIcons } from '../../UtilsCompletePage/getCustomCompletePageIcons'
import { getIconFromCustomCompletePage } from '../../UtilsCompletePage/getIconFromCustomCompletePage'
import { getThemeFromCustomCompletePage } from '../../UtilsCompletePage/getThemeFromCustomCompletePage'
import { getUploadImageFromCustomCompletePage } from '../../UtilsCompletePage/getUploadImageFromCustomCompletePage'
import { upsertCustomCompletePageIconTag } from '../../UtilsCompletePage/upsertCustomCompletePageIconTag'
import { StateCustomPageEditorProps } from './CustomPageEditor'
import { CustomUpload } from './CustomUpload'

type OptionType = 'Icons' | 'Upload'
const CustomIcon = ({ data, setData }: StateCustomPageEditorProps) => {
  const [option, setOption] = useState<OptionType>('Icons')

  const currentUpload = getUploadImageFromCustomCompletePage(data)
  const currentIcon = getIconFromCustomCompletePage(data)
  const onChangeIcon = (
    content: string | null | undefined,
    newIconKey: string
  ) => {
    const newContent = upsertCustomCompletePageIconTag(content, newIconKey)
    setData(newContent)
  }

  const currentTheme = getThemeFromCustomCompletePage(data) || '#51a855'
  return (
    <div className="my-4 flex w-full items-center justify-center">
      <Tooltip mouseEnterDelay={0.2} title="Click to edit">
        <Popover
          content={
            <div className="flex w-full flex-col items-center gap-3">
              <Segmented
                onChange={(value) => setOption(value as OptionType)}
                options={['Icons', 'Upload']}
                rootClassName="[&_.ant-segmented-item]:!m-0 w-[fit-content]"
              />
              {option === 'Icons' ? (
                <div className="grid w-full grid-cols-5 gap-2">
                  {Object.entries(
                    getCustomCompletePageIcons({
                      className: 'text-2xl !text-gray-500/80',
                    })
                  ).map(([key, icon]) => (
                    <button
                      className="flex h-10 w-10 items-center justify-center rounded bg-gray-100 !outline-none hover:bg-gray-200/70"
                      key={key}
                      onClick={() => onChangeIcon(data, key)}
                    >
                      {icon}
                    </button>
                  ))}
                </div>
              ) : null}
              {option === 'Upload' ? (
                <CustomUpload {...{ data, setData }} />
              ) : null}
            </div>
          }
          trigger="click"
        >
          {currentIcon ? (
            <ModalSuccess.Icon
              className="my-0 border-2 border-transparent hover:border-primary"
              style={{ background: currentTheme + '1a' }}
            >
              {
                getCustomCompletePageIcons({
                  style: { color: currentTheme },
                })[currentIcon]
              }
            </ModalSuccess.Icon>
          ) : null}
          {currentUpload && (
            <div className="relative h-32 w-32 cursor-pointer overflow-hidden rounded border-2 border-transparent hover:border-primary">
              <img
                alt="Preview"
                className="h-full w-full object-cover"
                src={currentUpload}
              />
            </div>
          )}
        </Popover>
      </Tooltip>
    </div>
  )
}

export { CustomIcon }
